import { useQuery } from '@tanstack/react-query';

import { billingInfoRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useBillingAccount = () => {
  const query = useQuery({
    queryKey: [QueryKeys.BILLING_ACCOUNT],
    queryFn: billingInfoRepo.getBillingAccount,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseBillingAccount = ReturnType<typeof useBillingAccount>;
